import { ButtonSlide } from '@vfit/shared/atoms';
import { ILoadingError } from './loadingError.models';
import { Container, Title, Description, InnerContainer, Subtitle, ButtonContainer } from './loadingError.style';
import { checkIsApp } from '@vfit/consumer/data-access';
import { trackLink, trackView } from '@vfit/shared/data-access';
import { useEffect } from 'react';

const LoadingError = ({loadingErrorConfig,setModal, error}: ILoadingError,) => {
  const { title, description, subtitle, buttonlabel } = loadingErrorConfig || {};
  useEffect(() => {
    trackView({
      event_name: 'page_error',
      event_category: ['error'],
      page_error: error?.status + '_' + (error?.body?.message || '') + '_' + (description || "Si è verificato un errore durante l'elaborazione del tuo ordine. Ci scusiamo per il disagio"),
      page_error_code: error?.status,
      journey_name: window['utag_data']?.journey_name || 'dynamic form',
      journey_type: window['utag_data']?.journey_type || 'journey',
      page_section: window['utag_data']?.page_section || 'dynamic form',
      page_subsection: window['utag_data']?.page_subsection || undefined,
    });
  }, []);
    
  const closeModal = () => {
    trackLink(buttonlabel || 'CALCOLA');
    setModal({ show: false });
  }
  return (
    <Container>
      <InnerContainer>
        <Title>{title || 'Ops!'}</Title>
        <Subtitle>{subtitle || 'Si è verificato un errore'}</Subtitle>
      </InnerContainer>

        <Description>
          {description ||
            "Si è verificato un errore durante l'elaborazione del tuo ordine. Ci scusiamo per il disagio"}
        </Description>
        <ButtonContainer>
            <ButtonSlide
              onClick={closeModal}
              label={buttonlabel || 'CALCOLA'}
              isApp={checkIsApp()}
              buttonColor="#e60000"
              labelColor="#fff"
              hoverColor="#bd0000"
              clickColor="#a10000"
              name="action_retrieveFiscalCode"
            />
        </ButtonContainer>
    </Container>
  );
};

export default LoadingError;

